import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Cookies from "js-cookie";
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import filter, { concat } from "lodash";
import _ from "lodash";
import { FetchDataTypes } from "../../api/api";


const PerformanceBalanceHistory = ({title}: any) => {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [mtdDays, setMtdDays] = useState<any>(null);
  const [setDate, setSetDate] = useState(365);
  const [currentPage, setCurrentPage] = useState(30);
  const [ytdDays, setYtdDays] = useState<any>(null);
  const [selected, setSelected] = useState([]);
  const [isselectedNASDAQComposite, setIsSelectedNASDAQComposite] = useState(null);
  const [NASDAQ, setNASDAQ] = useState(false)
  const [first, setfirst] = useState<any>(null)
  const [second, setSecond] = useState<any>(null)
  const [third, setThird] = useState<any>(null)

  const [benchMarkLabel, setBenchMarkLabel] = useState<any>(null);
  const [selectBenchMark, setSelectBenchMark] = useState<any>(null);
  const obj = { indexBenchmarkID: 0, indexBenchmarkName: "Select BenchMark" };
  //var toDate =
  const BeginDate = new Date(Date.now() - setDate * 24 * 60 * 60 * 1000);
  const EndDate = new Date();
  const yfd = new Date(EndDate.getFullYear(), 0, 1);
  const countDays = Math.abs(EndDate.getTime() - yfd.getTime());
  const ytd = countDays / (1000 * 3600 * 24);
  const a = moment().isBetween(BeginDate, EndDate);


  function getFirstDayOfMonth(year: any, month: any) {
    return new Date(year, month, 1);
  }

  const firstDayCurrentMonth = getFirstDayOfMonth(
    EndDate.getFullYear(),
    EndDate.getMonth()
  );
  const mtdCountDays = Math.abs(
    EndDate.getTime() - firstDayCurrentMonth.getTime()
  );
  const MTD = mtdCountDays / (1000 * 3600 * 24);


  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("PerfBalanceHistory",parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
    setCurrentPage(setDate);
  }, [setDate]);

  const [testData, settestData] = useState(second)
  

  
  

  useEffect(() => {
    setYtdDays(ytd.toFixed(0));
    setMtdDays(MTD.toFixed(0));
  }, [ytd, MTD]);

  var filteredData =
    sectorAllocation?.filter((e: any) => {
      var date = new Date(e.transactionDate);
      return date >= BeginDate && date <= EndDate;
    });
  

  let options = {
    chart: {
      zoomType: "xy",
    width: 1100,
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        backgroundColor: "rgb(240,241,248)",
        marker: {
          enabled: false,
        },
        pointWidth: 10
      },
    },
    xAxis: [
      {
        categories:
          filteredData &&
          filteredData.map((e: any) => {
            let newDate =  e.transactionDate ;
            return moment(newDate).format('MMMM Do YYYY');
          }),
        crosshair: true,
      },
    ],
    yAxis: [
      {
        // Primary yAxis

        labels: {
          allowDecimals: true,
          format: "{value}%",
          style: {
            color: "#806E89",
          },
        },
        title: {
          text: "Performance",
          style: {
            color: "#806E89",
          },
        },
      },
      {
        // Secondary yAxis

        title: {
          text: "Market Value",
          style: {
            color: "#806E89",
          },
        },
        labels: {
          allowDecimals: true,
          formatter: function (this: any): any {
            return "$" + parseFloat(this.value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          },
          style: {
            color: "#806E89",
          },
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    legend: {
      layout: "horizontal",
      align: "center",
      x: 0,
      verticalAlign: "bottom",
      y: 0,
      floating: false,
      backgroundColor: "rgba(255,255,255,0.25)",
      itemMarginTop: 0,
    },
    series: [
      {
        marker: {
          enabled: false,
        },
        name: "Balance",
        type: "column",
        yAxis: 1,
        pointWidth: '10',
        data:
          filteredData &&
          filteredData.map((e: any) => {
            return e.marketValue;
          }),
          color: "#3a7ddd",
        tooltip: {
          valueSuffix: "",
        },
      },
      {
        name: "Performance",
        type: "spline",
        data:
          filteredData &&
          filteredData.map((e: any) => {
            return e.rateOfReturn;
          }),
          color: "#000",
        tooltip: {
          valueSuffix: "",
        },
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 1000,
          },
        },
      ],
    },
  };

  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title float-start">{title ? title : "Performance Balance History"}</h5>

        <div className="float-end">
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-end Portfolio_chat">
              <li
                className={
                  (currentPage !== mtdDays ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(mtdDays)}
              >
                <span className="page-link"> MTD</span>
              </li>
              <li
                className={
                  (currentPage !== 90 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(90)}
              >
                <span className="page-link"> 3M</span>
              </li>
              <li
                className={
                  (currentPage !== 180 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(180)}
              >
                <span className="page-link"> 6M</span>
              </li>
              <li
                className={
                  (currentPage !== ytdDays ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(ytdDays)}
              >
                <span className="page-link"> YTD</span>
              </li>
              <li
                className={
                  (currentPage !== 365 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(365)}
              >
                <span className="page-link"> 1Y</span>
              </li>
            </ul>
          </nav>
        </div>
        
      </div>

      <div className="card-body d-flex w-100">
        <div className="align-self-center chart chart-lg">
          <div className="chartjs-size-monitor hight-chart">
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              oneToOne={true}
              width="1000px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { PerformanceBalanceHistory };
